import {
  Breadcrumb,
  Button,
  TableBasic,
  Tooltip,
  Tab,
  TabPane,
} from "prosperita-dumbo-react";
import Margin from "~/components/Margin";
import styled from "styled-components";

import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import editIcon from "~/assets/Edit.png";

import addIcon from "~/assets/Addd.png";
import {
  formatCPFCNPJ,
  formatPhoneNumber,
  getLabelByValue,
} from "~/services/utils";
import { format } from "date-fns";

import useLoading from "~/hooks/useLoading";

import {
  getPersonDetailsAPI,
  getCompanyDetailsAPI,
  IPartner,
  IPartnerCompany,
} from "~/services/api/partner";
import usePartner from "~/hooks/usePartner";
import { getBankAccountsAPI, IBankAccount } from "~/services/api/bankAccount";
import AddBankAccount from "./AddBankAccount";
import {
  bussinesSectorOptions,
  entityOptions,
  genderOptions,
  maritalStatusOptions,
  residenceOptions,
} from "~/utils/options";
import EditBankAccount from "./EditBankAccount";
import lockIcon from "~/assets/lock.png";

// import { getPartnerPersonAPI, getPartnersAPI } from "~/services/api/partner";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: start;
`;

const TitleContainer = styled.div`
  background-color: #f4f4f4;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 18px 32px;
`;

const TitleBar = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  gap: 16px;
`;

const Title = styled.h1`
  font-family: IBM Plex Sans;
  font-size: 32px;
  font-weight: 300;
  line-height: 40px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

const Content = styled.div`
  width: 100%;
  padding: 24px 32px;
`;

const TagLup = styled.img`
  object-fit: contain;
  width: 200px;
  margin: 20px 0;
`;

const Text = styled.h4`
  color: #161616;
  font-family: "IBM Plex Sans";
  font-size: 21px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: 20px;
`;

const Subtext = styled.h4`
  color: #161616;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin-top: 20px;
`;

const titlesColumnBankAccounts = ["Instituição", "Agência", "Conta", ""];

// Type guards
const isPerson = (partner: any): partner is IPartner => {
  return partner?.document_type === "person";
};

const isCompany = (partner: any): partner is IPartnerCompany => {
  return partner?.document_type === "company";
};

const ContactsDetails = () => {
  const { uuid } = useParams();
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determina o tipo baseado na rota atual
  const contactType = location.pathname.includes('/person/') ? 'person' : 'company';
  


  const {
    setPartner,
    partner,
    bankAccounts,
    setBankAccounts,
    setAddBankAccounts,
    setAddDocument,
    setBankAccountData,
  } = usePartner();

  const canReadContacts = useMemo(() => true, []);
  const canEditContacts = useMemo(() => true, []);


  const bankAccountsData = bankAccounts?.map((bankAccount: IBankAccount) => {
    return {
      Instituição: `${bankAccount.bank_code} - ${bankAccount.bank_name}`,
      Agência: bankAccount.agency_digit
        ? `${bankAccount.agency}-${bankAccount.agency_digit}`
        : bankAccount.agency,
      Conta: `${bankAccount.account_number}-${bankAccount.account_number_digit}`,
      actionsColumn: canEditContacts ? (
        <Tooltip align="top" size="medium" label="Editar">
          <div
            style={{
              position: "relative",
              top: "-8px",
              height: "20px",
            }}
          >
            <Button
              kind="ghost"
              size="small"
              icon={editIcon}
              label=""
              onClick={() => setBankAccountData(bankAccount)}
            />
          </div>
        </Tooltip>
      ) : (
        <div></div>
      ),
    };
  });



  const fetchBankAccounts = useCallback(async () => {
    try {
      if (uuid) {
        const { data } = await getBankAccountsAPI(uuid);

        setBankAccounts(data.payload.reverse());
      } else {
        console.error("UUID is undefined");
      }
    } catch (err) {
      console.error("Erro ao buscar detalhes da operação:", err);
    }
  }, [uuid, setBankAccounts]);

  const fetchPartnerDetails = useCallback(async () => {
    setPartner(null);
    setLoading(true);
    try {
      if (uuid) {
    
        
        // Usa a API específica baseada no tipo de contato
        const { data } = contactType === 'person' 
          ? await getPersonDetailsAPI(uuid)
          : await getCompanyDetailsAPI(uuid);

     
        setPartner(data.payload);

        await fetchBankAccounts();

        setLoading(false);
      } else {
        console.error("UUID is undefined");
        setLoading(false);
      }
    } catch (err) {
      console.error("Erro ao buscar detalhes da operação:", err);
      console.error("Error details:", {
        uuid,
        contactType,
        pathname: location.pathname,
        error: err
      });
      setLoading(false);
    }
  }, [uuid, setLoading, setPartner, fetchBankAccounts, contactType, location.pathname]);

  useEffect(() => {
    fetchPartnerDetails();
  }, [fetchPartnerDetails]);

  interface IRenderContent {
    content?: JSX.Element;
    tab: string;
    label: string;
    size?: string;
    position?: "left" | "center" | "right";
  }

  const [tab, setTab] = useState<string>("bank_accounts");

  const renderContent: IRenderContent[] = useMemo(() => {
    return [
      {
        content: (
          <div style={{ marginTop: "20px" }}>
            <TableBasic
              search
              sizeSearch="large"
              pageSizes={[5, 10, 20, 50, 100]}
              columnTitles={titlesColumnBankAccounts}
              rowData={bankAccountsData}
              width="1000px"
              buttons={[
                {
                  kind: "primary",
                  position: "right",
                  size: "large",
                  disabled: !canEditContacts,
                  label: "Adicionar conta bancária",
                  icon: addIcon,
                  onClick: () => setAddBankAccounts(true),
                },
              ]}
            />
          </div>
        ),
        tab: "bank_accounts",
        label: "Contas bancárias",
        size: "150px",
        position: "left",
      },

     
    ];
  }, [
    bankAccountsData,
    canEditContacts,
    setAddBankAccounts,
    setAddDocument,
  ]);

  // Se ainda está carregando, mostra loading
  if (!partner && !canReadContacts) {
    return <div>Carregando...</div>;
  }

  return (
    <>
      <Container>
        <TitleContainer>
          <Breadcrumb
            crumbsOptions={[
              {
                crumb: "Contatos",
                onClick: () => navigate("/app/contacts"),
              },
              {
                crumb: "Detalhes",
              },
            ]}
            endHiddenIndex={5}
            startHiddenIndex={5}
            aria-label="Navegação de detalhes de operações"
          />
          {canReadContacts && (
            <TitleBar>
              <Title style={{ fontFamily: "sans-serif", fontSize: "25px" }}>
                {partner?.name || "Carregando..."}
              </Title>
            </TitleBar>
          )}
        </TitleContainer>

        <Content>
          {canReadContacts && (
            <>
              <h3 style={{ fontSize: "24px" }}>Dados básicos</h3>
              {/* <Margin top={10} /> */}
              <div
                style={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr 1fr",
                  gap: "32px",
                  rowGap: "30px",
                  marginTop: "20px",
                }}
              >
                {[
                  {
                    label:
                      partner?.document_type === "company" ? "CNPJ" : "CPF",
                    value: partner?.document_number
                      ? formatCPFCNPJ(String(partner?.document_number))
                      : "-",
                  },
                  ...(isPerson(partner)
                    ? [
                        {
                          label: "Data de nascimento",
                          value: partner?.birth_date
                            ? format(
                                new Date(partner?.birth_date),
                                "dd/MM/yyyy"
                              )
                            : "-",
                        },
                        {
                          label: "Nacionalidade",
                          value: partner?.nationality || "-",
                        },
                        {
                          label: "Estado civil",
                          value: getLabelByValue(
                                partner?.marital_status,
                                maritalStatusOptions
                              ) || "-",
                        },
                        {
                          label: "Nome da mãe",
                          value: partner?.mother_name || "-",
                        },
                        {
                          label: "Nome do pai",
                          value: partner?.father_name || "-",
                        },
                        {
                          label: "Gênero",
                          value: getLabelByValue(partner?.gender, genderOptions) || "-",
                        },
                      ]
                    : isCompany(partner) ? [
                        {
                          label: "Data de fundação",
                          value: partner.foundation_date
                            ? format(
                                new Date(partner.foundation_date),
                                "dd/MM/yyyy"
                              )
                            : "-",
                        },
                        {
                          label: "CNAE",
                          value: partner.cnae || "-",
                        },
                        {
                          label: "Natureza jurídica",
                          value: (partner.legal_nature &&
                                getLabelByValue(
                                  partner.legal_nature,
                                  entityOptions
                                )) || "-",
                        },
                        {
                          label: "Inscrição estadual",
                          value: partner.state_registration || "-",
                        },

                        {
                          label: "Setor de atuação",
                          value: (partner.business_sector &&
                                getLabelByValue(
                                  partner.business_sector,
                                  bussinesSectorOptions
                                )) || "-",
                        },
                        {
                          label: "Site",
                          value: partner.website || "-",
                        },
                        {
                          label: "Nome fantasia",
                          value: partner.fantasy_name || "-",
                        },
                        {
                          label: "Inscrição municipal",
                          value: partner.municipal_registration || "-",
                        },
                        {
                          label: "Código do empregador",
                          value: partner.employer_code || "-",
                        },
                        {
                          label: "Conta B3",
                          value: partner.b3_account || "-",
                        },
                      ] : []),

                  {
                    label: "Email",
                    value: `${
                      partner?.contact?.email ? partner.contact.email : "-"
                    }`,
                  },

                  {
                    label: "Telefone",
                    value: ` ${partner?.contact?.phone ? formatPhoneNumber(partner.contact.phone) : "-"}`,
                  },
                ].map((item, index) => (
                  <div key={index}>
                    <p style={{ color: "#525252" }}>{item.label}</p>
                    <h4>{item.value}</h4>
                  </div>
                ))}
              </div>
              <Margin mt={40} />
              {partner?.address && (
                <h3 style={{ fontSize: "24px" }}>Endereço</h3>
              )}
              {/* <Margin top={10} /> */}
              <div
                style={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr 1fr",
                  gap: "32px",
                  rowGap: "30px",
                  marginTop: "20px",
                }}
              >
                {[
                  ...(partner?.address
                    ? [
                        {
                          label: "Logradouro",
                          value: partner?.address?.street || "-",
                        },
                        {
                          label: "Número",
                          value: partner?.address?.number || "-",
                        },
                        {
                          label: "Complemento",
                          value: partner?.address?.additional_info || "-",
                        },
                        {
                          label: "Bairro",
                          value: partner?.address?.district || "-",
                        },
                        {
                          label: "Cidade",
                          value: partner?.address?.city || "-",
                        },
                        {
                          label: "Estado",
                          value: partner?.address?.state || "-",
                        },
                        {
                          label: "CEP",
                          value: partner?.address?.zip_code || "-",
                        },
                        {
                          label: "Tipo de endereço",
                          value:
                            getLabelByValue(
                              partner?.address.type,
                              residenceOptions
                            ) || "-",
                        },
                      ]
                    : []),
                ].map((item, index) => (
                  <div key={index}>
                    <p style={{ color: "#525252" }}>{item.label}</p>
                    <h4>{item.value}</h4>
                  </div>
                ))}
              </div>
              
              {/* Seção de Documento de Identificação - apenas para pessoa física */}
              {isPerson(partner) && partner?.identification_document && (
                <>
                  <Margin mt={40} />
                  <h3 style={{ fontSize: "24px" }}>Documento de Identificação</h3>
                  <div
                    style={{
                      width: "100%",
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr 1fr",
                      gap: "32px",
                      rowGap: "30px",
                      marginTop: "20px",
                    }}
                  >
                    {[
                      {
                        label: "Tipo de documento",
                        value: partner?.identification_document?.document_type || "-",
                      },
                      {
                        label: "Número do documento",
                        value: partner?.identification_document?.document || "-",
                      },
                      {
                        label: "Data de emissão",
                        value: partner?.identification_document?.emission_date
                          ? format(
                              new Date(partner?.identification_document?.emission_date),
                              "dd/MM/yyyy"
                            )
                          : "-",
                      },
                      {
                        label: "Data de validade",
                        value: partner?.identification_document?.expiration_date
                          ? format(
                              new Date(partner?.identification_document?.expiration_date),
                              "dd/MM/yyyy"
                            )
                          : "-",
                      },
                      {
                        label: "Estado emissor",
                        value: partner?.identification_document?.issuing_state || "-",
                      },
                      {
                        label: "PEP",
                        value: partner?.identification_document?.pep ? "Sim" : "Não",
                      },
                    ].map((item, index) => (
                      <div key={index}>
                        <p style={{ color: "#525252" }}>{item.label}</p>
                        <h4>{item.value}</h4>
                      </div>
                    ))}
                  </div>
                </>
              )}

              {/* Seção de Informações Profissionais - apenas para pessoa física */}
              {isPerson(partner) && partner?.professional_info && (
                <>
                  <Margin mt={40} />
                  <h3 style={{ fontSize: "24px" }}>Informações Profissionais</h3>
                  <div
                    style={{
                      width: "100%",
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr 1fr",
                      gap: "32px",
                      rowGap: "30px",
                      marginTop: "20px",
                    }}
                  >
                    {[
                      {
                        label: "Natureza da ocupação",
                        value: partner?.professional_info?.occupation_nature || "-",
                      },
                      {
                        label: "Status de emprego",
                        value: partner?.professional_info?.employment_status || "-",
                      },
                      {
                        label: "Salário líquido",
                        value: partner?.professional_info?.net_salary
                          ? `R$ ${partner?.professional_info?.net_salary.toLocaleString('pt-BR')}`
                          : "-",
                      },
                      {
                        label: "Renda adicional",
                        value: partner?.professional_info?.additional_income
                          ? `R$ ${partner?.professional_info?.additional_income.toLocaleString('pt-BR')}`
                          : "-",
                      },
                      {
                        label: "Data de contratação",
                        value: partner?.professional_info?.hiring_date
                          ? format(
                              new Date(partner?.professional_info?.hiring_date),
                              "dd/MM/yyyy"
                            )
                          : "-",
                      },
                      {
                        label: "Número do funcionário",
                        value: partner?.professional_info?.employee_number || "-",
                      },
                      {
                        label: "Departamento",
                        value: partner?.professional_info?.department || "-",
                      },
                    ].map((item, index) => (
                      <div key={index}>
                        <p style={{ color: "#525252" }}>{item.label}</p>
                        <h4>{item.value}</h4>
                      </div>
                    ))}
                  </div>
                </>
              )}

              {/* Seção de Pais - apenas para pessoa física */}
              {isPerson(partner) && partner?.parents && partner?.parents.length > 0 && (
                <>
                  <Margin mt={40} />
                  <h3 style={{ fontSize: "24px" }}>Informações dos Pais</h3>
                  <div
                    style={{
                      width: "100%",
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr 1fr",
                      gap: "32px",
                      rowGap: "30px",
                      marginTop: "20px",
                    }}
                  >
                    {partner?.parents.map((parent, parentIndex) => (
                      <div key={parentIndex} style={{ gridColumn: "1 / -1" }}>
                        <h4 style={{ marginBottom: "16px", color: "#161616" }}>
                          {parent.parent_type === "mother" ? "Mãe" : "Pai"}
                        </h4>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 1fr 1fr",
                            gap: "32px",
                            rowGap: "30px",
                            padding: "16px",
                            backgroundColor: "#f9f9f9",
                            borderRadius: "8px",
                          }}
                        >
                          {[
                            {
                              label: "Nome",
                              value: parent.name || "-",
                            },
                            {
                              label: "CPF",
                              value: parent.document_number
                                ? formatCPFCNPJ(String(parent.document_number))
                                : "-",
                            },
                            {
                              label: "CNPJ da empresa",
                              value: parent.company_document_number
                                ? formatCPFCNPJ(String(parent.company_document_number))
                                : "-",
                            },
                            {
                              label: "Ocupação",
                              value: parent.occupation || "-",
                            },
                            {
                              label: "Telefone",
                              value: parent.phone ? formatPhoneNumber(parent.phone) : "-",
                            },
                            {
                              label: "Data de nascimento",
                              value: parent.birth_date
                                ? format(new Date(parent.birth_date), "dd/MM/yyyy")
                                : "-",
                            },
                            {
                              label: "Salário líquido",
                              value: parent.net_salary
                                ? `R$ ${parent.net_salary.toLocaleString('pt-BR')}`
                                : "-",
                            },
                            {
                              label: "Renda adicional",
                              value: parent.additional_income
                                ? `R$ ${parent.additional_income.toLocaleString('pt-BR')}`
                                : "-",
                            },
                          ].map((item, index) => (
                            <div key={index}>
                              <p style={{ color: "#525252" }}>{item.label}</p>
                              <h4>{item.value}</h4>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}

              {/* Seção de Informações Financeiras - apenas para empresa */}
              {isCompany(partner) && partner?.finantial_info && (
                <>
                  <Margin mt={40} />
                  <h3 style={{ fontSize: "24px" }}>Informações Financeiras</h3>
                  <div
                    style={{
                      width: "100%",
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr 1fr",
                      gap: "32px",
                      rowGap: "30px",
                      marginTop: "20px",
                    }}
                  >
                    {[
                      {
                        label: "Capital social inicial",
                        value: partner?.finantial_info?.initial_share_capital
                          ? `R$ ${partner?.finantial_info?.initial_share_capital.toLocaleString('pt-BR')}`
                          : "-",
                      },
                      {
                        label: "Patrimônio líquido",
                        value: partner?.finantial_info?.net_equity
                          ? `R$ ${partner?.finantial_info?.net_equity.toLocaleString('pt-BR')}`
                          : "-",
                      },
                      {
                        label: "Número de funcionários",
                        value: partner?.finantial_info?.number_of_employees
                          ? partner?.finantial_info?.number_of_employees.toLocaleString('pt-BR')
                          : "-",
                      },
                      {
                        label: "Receita média mensal",
                        value: partner?.finantial_info?.average_monthly_revenue
                          ? `R$ ${partner?.finantial_info?.average_monthly_revenue.toLocaleString('pt-BR')}`
                          : "-",
                      },
                      {
                        label: "Lucro bruto médio",
                        value: partner?.finantial_info?.average_gross_profit
                          ? `R$ ${partner?.finantial_info?.average_gross_profit.toLocaleString('pt-BR')}`
                          : "-",
                      },
                      {
                        label: "Percentual de exportação",
                        value: partner?.finantial_info?.exportation_percentage
                          ? `${partner?.finantial_info?.exportation_percentage}%`
                          : "-",
                      },
                      {
                        label: "Custo com fornecedores",
                        value: partner?.finantial_info?.suppliers_cost
                          ? `R$ ${partner?.finantial_info?.suppliers_cost.toLocaleString('pt-BR')}`
                          : "-",
                      },
                      {
                        label: "Custo com impostos",
                        value: partner?.finantial_info?.tax_cost
                          ? `R$ ${partner?.finantial_info?.tax_cost.toLocaleString('pt-BR')}`
                          : "-",
                      },
                      {
                        label: "Receita últimos 12 meses",
                        value: partner?.finantial_info?.last_12_months_revenue
                          ? `R$ ${partner?.finantial_info?.last_12_months_revenue.toLocaleString('pt-BR')}`
                          : "-",
                      },
                      {
                        label: "Valor locado/financiado",
                        value: partner?.finantial_info?.leased_or_financed_value
                          ? `R$ ${partner?.finantial_info?.leased_or_financed_value.toLocaleString('pt-BR')}`
                          : "-",
                      },
                      {
                        label: "Valor da folha de pagamento",
                        value: partner?.finantial_info?.payroll_value
                          ? `R$ ${partner?.finantial_info?.payroll_value.toLocaleString('pt-BR')}`
                          : "-",
                      },
                      {
                        label: "PMV",
                        value: partner?.finantial_info?.pmv
                          ? `R$ ${partner?.finantial_info?.pmv.toLocaleString('pt-BR')}`
                          : "-",
                      },
                      {
                        label: "Potencial de financiamento",
                        value: partner?.finantial_info?.funding_potential
                          ? `R$ ${partner?.finantial_info?.funding_potential.toLocaleString('pt-BR')}`
                          : "-",
                      },
                      {
                        label: "Percentual de vendas em atraso",
                        value: partner?.finantial_info?.late_sales_percentage
                          ? `${partner?.finantial_info?.late_sales_percentage}%`
                          : "-",
                      },
                    ].map((item, index) => (
                      <div key={index}>
                        <p style={{ color: "#525252" }}>{item.label}</p>
                        <h4>{item.value}</h4>
                      </div>
                    ))}
                  </div>
                </>
              )}

              <Margin mb={50} />
              <Tab width="1000px">
                {renderContent.map((list) => (
                  <TabPane
                    isActive={list.tab === tab}
                    width={list.size}
                    position={list.position}
                    bordercolor="rgb(10, 74, 135)"
                    onClick={() => setTab(list.tab)}
                    label={list.label}
                    disabled={list.tab === "consigned"}
                  >
                    <div
                      style={{
                        marginBottom: "58px",
                        marginLeft: "auto",
                        marginRight: "auto",
                        paddingTop: "30px",
                        width: "100%",
                      }}
                    >
                      {list.content}
                    </div>
                  </TabPane>
                ))}
              </Tab>
              <Margin mt={50} />
            </>
          )}
          {!canReadContacts && (
            <div>
              <Margin mt={70} />
              <TagLup
                src={lockIcon}
                aria-label="Ícone indicando não há permissão para visualizar as operações"
              />
              <Margin mt={30} />
              <Text>Acesso restrito</Text>

              <Subtext>
                Você não tem permissão para ver os contatos
                <br /> contate o administrador do sistema para mais informações.
              </Subtext>
            </div>
          )}
        </Content>
        <div style={{ zIndex: "999" }}>
          <AddBankAccount />
          <EditBankAccount />
        
        </div>
      </Container>
    </>
  );
};

export default ContactsDetails;
